import { render, staticRenderFns } from "./LegacyChatbot.vue?vue&type=template&id=68d703e6&scoped=true"
import script from "./LegacyChatbot.vue?vue&type=script&lang=js"
export * from "./LegacyChatbot.vue?vue&type=script&lang=js"
import style0 from "./LegacyChatbot.vue?vue&type=style&index=0&id=68d703e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d703e6",
  null
  
)

export default component.exports